const stateConstants = {
  GET_ALL_STATES_START: "GET_ALL_STATES_START",
  GET_ALL_STATES_SUCCESS: "GET_ALL_STATES_SUCCESS",
  GET_ALL_STATES_FAILED: "GET_ALL_STATES_FAILED",
  ADD_STATE_START: "ADD_STATE_START",
  ADD_STATE_END: "ADD_STATE_END",
  ADD_STATE_FAILED: "ADD_STATE_FAILED",
  VIEW_STATE_START: "VIEW_STATE_START",
  VIEW_STATE_SUCCESS: "VIEW_STATE_SUCCESS",
  VIEW_STATE_FAILED: "VIEW_STATE_FAILED",
  EDIT_STATE_START: "EDIT_STATE_START",
  EDIT_STATE_END: "EDIT_STATE_END",
  EDIT_STATE_FAILED: "EDIT_STATE_FAILED",
  EDIT_STATE_SUCCESS: "EDIT_STATE_SUCCESS",
};

export default stateConstants;
